// @ts-nocheck
import React, { useState, useEffect } from "react";
import { RUTA_API_RECIBOS } from "../Contantes/Constantes";
import RecibosTable from "./RecibosTable";
import KeyCloak from "../Auth/Keycloak";
import axios from 'axios';
import { setupInterceptorsTo } from "../Componentes/API/AxiosBuilder";
import { useBody } from "../Body/state/BodyContext";
import { useAuth } from "../Auth/State/AuthContext";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { makeStyles } from "@mui/styles";
import SinapThemev2 from "../styles/SinapThemev2";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Alert from "@mui/material/Alert";


const useStyles = makeStyles(theme => ({
    typografy: {
        marginTop: '2%',
        width: "100%",
        color: SinapThemev2.palette.primary.main,
    }
}))

export default function Recibo() {
    const classes = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('md'));
    const [recibos, setRecibos] = useState([]);
    const [load, setLoad] = useState(true);
    const axiosInstance = setupInterceptorsTo(axios.create());
    const { setMessage, setInfo } = useBody();
    const { user, isLogedIn } = useAuth();

    const getRecibos = async () => {
        await axiosInstance({
            method: 'GET',
            url: `${RUTA_API_RECIBOS}/${user.legajoPersonaUTN}`,
        })
            .then(response => {
                if (response.data.length === 0)
                    setInfo("Usted no posee recibos para visualizar")
                setRecibos(response.data);
                setLoad(false);
            }).catch(error => {
                setMessage("Hubo un error al traer los recibos (Codigo de error: 00030)")
            })
    }

    const downloadRecibo = async (recibo) => {
        try {
            const response = await axiosInstance({
                method: 'GET',
                url: `${RUTA_API_RECIBOS}/${user.legajoPersonaUTN}/${recibo.name}/download`,
                responseType: "blob",
            });
    
            const url = window.URL.createObjectURL(response.data);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `${recibo.name_for_client}.pdf`; // filename
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error al descargar el recibo:", error);
            setMessage("Hubo un error al descargar el recibo (Código de error: 00031)");
        }
    };

    useEffect(() => {
        if (user.legajoPersonaUTN)
            getRecibos();
    }, [user.legajoPersonaUTN])

    return (
        <>
            <Typography
                my={"40px"}
                mx="10px"
                fontSize={matches ? "28px" : "30px"}
            >
                Recibos
            </Typography>
            <br />
            <RecibosTable
                recibos={recibos}
                load={load}
                downloadRecibo={downloadRecibo}
            />
            <br />
            <Alert severity="info">En caso de necesitar mas ayuda también puede <b>Contactarse con
                Soporte</b> enviando un mail a soporte@frba.utn.edu.ar</Alert>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
        </>
    )
}